import type { AxiosResponse } from "axios";
import { api } from "../axiosInstance";
import { getBaseUrl } from "../api";

const ENDPOINTS = {
  post: `${getBaseUrl()}/journal-entries`,
  getAll: `${getBaseUrl()}/journal-entries`,
  getPending: `${getBaseUrl()}/journal-entries/pending`,
  patchEntries: `${getBaseUrl()}/journal-entries`,
  patchPendingEntry: `${getBaseUrl()}/journal-entries/pending`,
};

export async function postJournalEntries(payload: any): Promise<any> {
  const resp: AxiosResponse = await api.post(ENDPOINTS.post, payload);
  return resp.data;
}

export async function getAllJournalEntries(
  offset: number,
  limit: number,
  search?: string
) {
  const params: any = { offset, limit };

  if (search && search.trim() !== "") {
    params.search = search;
  }

  const resp = await api.get(ENDPOINTS.getAll, { params });
  return resp.data;
}

export async function getAllPendingEntries(
  offset: number,
  limit: number,
  search?: string
) {
  const params: any = { offset, limit };

  if (search && search.trim() !== "") {
    params.search = search;
  }

  const resp = await api.get(ENDPOINTS.getPending, { params });
  return resp.data;
}

export async function patchJournalEntries(reconRefNo: string, payload: {
  auth_status: string;
  post_status: string;
  comments?: string;
}): Promise<any> {
  const resp: AxiosResponse = await api.patch(
    `${ENDPOINTS.patchEntries}/${reconRefNo}`,
    payload
  );

  return resp.data;
}

export async function patchPendingEntries(
  reconRefNo: string,
  payload: {
    auth_status: string;
    post_status: string;
    comments?: string;
    entries: any[];
  }
): Promise<any> {
  const resp: AxiosResponse = await api.patch(
    `${ENDPOINTS.patchPendingEntry}/${reconRefNo}`,
    payload
  );

  return resp.data;
}

export async function searchPendingJournalEntries(
  offset: number,
  limit: number,
  reconRefNo: string
) {
  const params: any = {
    offset,
    limit,
    query: reconRefNo.trim(), 
  };

  const resp = await api.get(ENDPOINTS.getPending, { params });
  return resp.data;
}
